import classnames from 'classnames';
import { CSSProperties, useEffect } from 'react';
import './index.less';
// import 'src/../public/icon-bass/icon-bass.css';

type IconBassProps = {
  type: string,
  style?: CSSProperties,
  className?: string,
  [key:string]: any
};

export default function IconBass(props:IconBassProps) {
  const {
    type,
    style = {},
    className = '',
    ...rest
  } = props;

  const siteName = process.env.REACT_APP_SITE_NAME;
  const baseEnv = process.env.REACT_APP_BASE_ENV;

  useEffect(() => {
    // @ts-ignore
    if (!IconBass.isInitIcon) {
      // @ts-ignore
      IconBass.isInitIcon = true;
      if (siteName !== 'hybrid') {
        // @ts-ignore
        import('../../../public/icon-bass/icon-bass.css');
      } else if (baseEnv === 'local') {
        // @ts-ignore
        import('../../../public/icon-bass/icon-bass.css');
      }
    }
  }, []);

  return (
    <i
      className={classnames(
        'ibass',
        `${type}`,
        className,
        {
          // 实际上只需要对 icon-bass 这个图标库加这个 class,不过对 icon-font 库即使加上了也无所谓。
          // 因为在 iLawweb 中 iconbass 的类名被改变了才能使用
          [`ibass-${type}`]: siteName === 'hybrid',
          'ibass-alpha-tool-compatibility-class-for-hybrid': siteName === 'hybrid',
        },
      )}
      style={style}
      {...rest}
    />
  );
}
